import { LitElement, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from '../../styles/mariana-list-button.css?inline';
import type { ButtonOption } from '../chat/types.js';

/**
 * List-style Button Component
 * Renders buttons in a list format with left-aligned text and right arrow
 */
@customElement('mariana-list-button')
export class MarianaListButton extends LitElement {
  static readonly styles = unsafeCSS(styles);

  @property({ type: Array })
  buttons: ButtonOption[] = [];

  private handleClick(button: ButtonOption) {
    this.dispatchEvent(
      new CustomEvent<ButtonOption>('button-click', {
        detail: button,
        bubbles: true,
        composed: true,
      })
    );
  }

  render() {
    return html`
      <div class="list-button-container">
        ${this.buttons.map(
      (button) => html`
            <button
              class="list-button"
              @click=${() => this.handleClick(button)}
            >
              <div class="list-button-label">
                <span class="list-button-title">${button.label}</span>
              </div>
              <span class="list-button-arrow"></span>
            </button>
          `
    )}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mariana-list-button': MarianaListButton;
  }
}
